interface DeepLinkProps {
  /** Adapter'in admin_link'i; yoksa duz metin gosterilir (sozlesme: "adapter admin_link; yoksa düz metin"). */
  href?: string | null;
  label: string;
  /**
   * true ise kod-degeri stili (siparis no/talep no gibi mono/kucuk yazi) —
   * varsayilan false (mevcut davranis: urun/isim linkleri, font-medium).
   * Geriye uyumlu ek prop (KPI detay modali "eşitleme" görevi).
   */
  mono?: boolean;
}

/** Platform derin bagi — `.deep-link` (index.css) + kucuk dis link ikonu. */
export function DeepLink({ href, label, mono = false }: DeepLinkProps) {
  if (!href) {
    return <span className={mono ? "font-mono text-xs text-muted" : "text-muted"}>{label}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`deep-link inline-flex min-h-[44px] items-center gap-1 ${mono ? "font-mono text-xs" : ""}`}
    >
      {label}
      <span aria-hidden="true" className="text-[10px] opacity-70">
        ↗
      </span>
    </a>
  );
}
